// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
export var spacingTokens = {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    xxl: 32
};
export var spacing = [
    0,
    4,
    8,
    12,
    16,
    20,
    24,
    28,
    32
];
export var pageMargin = {
    m: 16,
    l: 32,
    xl: 60
};
export var borderRadius = {
    default: 8,
    small: 4,
    tiny: 2,
    none: 0,
    /**
     * Note: `large` is not a supported border radius size in the Aurora Design System Figma spec
     * @internal
     */ large: 40
};
export var condensedSpacing = [
    0,
    2,
    4,
    6,
    8,
    12,
    16
];
export var pageBreakpoints = {
    xl: 1536,
    lg: 1200,
    md: 900,
    sm: 600,
    xs: 0
};

//# sourceMappingURL=spacing.js.map